import React from 'react';
import { TouchableOpacity, StyleSheet, Platform, ViewStyle, StyleProp } from 'react-native';
import MaterialIcons from 'react-native-vector-icons/MaterialIcons';
import { AdminColors } from '../Admin/constants/adminColors';
import { useDarkStyles } from '../../theme/useDarkStyles';

interface Props {
  onPress: () => void;
  iconName?: string;
  accessibilityLabel?: string;
  style?: StyleProp<ViewStyle>;
}

const PerfectTruckFab: React.FC<Props> = ({
  onPress,
  iconName = 'add',
  accessibilityLabel = 'Create',
  style,
}) => {
  const styles = useDarkStyles(baseStyles);
  return (
    <TouchableOpacity
      style={[styles.fab, style]}
      onPress={onPress}
      activeOpacity={0.85}
      accessibilityRole="button"
      accessibilityLabel={accessibilityLabel}
    >
      <MaterialIcons name={iconName} size={28} color={AdminColors.textOnDark} />
    </TouchableOpacity>
  );
};

const baseStyles = StyleSheet.create({
  fab: {
    position: 'absolute',
    right: 20,
    bottom: 24,
    width: 56,
    height: 56,
    borderRadius: 16,
    backgroundColor: AdminColors.blue700,
    alignItems: 'center',
    justifyContent: 'center',
    ...Platform.select({
      web: { boxShadow: '0 4px 16px rgba(0,92,188,0.3)' } as any,
      default: {
        elevation: 6,
        shadowColor: AdminColors.blue700,
        shadowOpacity: 0.3,
        shadowRadius: 8,
        shadowOffset: { width: 0, height: 4 },
      },
    }),
  },
});

export default PerfectTruckFab;
